import React from 'react'
import { Outlet } from 'react-router-dom'
import { BottomNav } from '../BottomNav'

/** Wraps showcase routes with the original white bottom navigation bar. */
export function ShowcaseLayout() {
  return (
    <div className="select-none">
      <Outlet />
      <BottomNav currentPage="showcase" />
    </div>
  )
}
